import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  hasOverlay: PropTypes.bool,
  size: PropTypes.number,
};

export default function Loading({ hasOverlay = true, size = 5 }) {
  return (
    <div
      className={hasOverlay ? 'dre-spinner-overlay' : 'empty-flex'}
      data-testid="dre-spinner-overlay"
      aria-hidden="true"
    >
      <div
        className={hasOverlay ? 'dre-spinner-overlay-wrapper' : 'dre-spinner-wrapper'}
        data-testid="dre-spinner-wrapper"
      >
        <span
          className={`loader dre-spinner-${size}`}
          data-testid="dre-spinner"
          data-variant="spinner"
        >
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span className="screen-reader-text">Loading...</span>
        </span>
      </div>
    </div>
  );
}

Loading.propTypes = propTypes;
